module.exports = __webpack_public_path__ + "static/media/ico_endpoint.1db23b46.svg";